/* Hocenlub — Collection page: nav hide on scroll-down, show on scroll-up.
   Burger + search are wired by the aerodisc-nav section's own inline script. */
(function () {
  var nav = document.getElementById('nav');
  if (!nav) return;
  var lastY = window.scrollY, tick = false;
  function frame() {
    var y = window.scrollY;
    var open = document.querySelector('.nav-links.open');
    if (!open && y > 140 && y > lastY + 4) { nav.classList.add('-hide'); }
    else if (y < lastY - 4 || y <= 140) { nav.classList.remove('-hide'); }
    lastY = y; tick = false;
  }
  window.addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(frame); tick = true; } }, { passive: true });
})();
